import * as React from 'react';

import styles from './Header.scss';
import { Logo } from 'components/catalogs/components/Logo/Logo';

type Props = {
  catalogCode: string;
  categories: Category[] | null;
  hasError: boolean;
};

type Category = {
  code: string;
  name: string;
};

const toCatalogCategoryPath = (catalogCode: string, categoryCode: string): string =>
  `/catalogs/${encodeURIComponent(catalogCode)}/categories/${encodeURIComponent(categoryCode)}`;

export const Header = ({ catalogCode, categories, hasError }: Props): JSX.Element => {
  const [isOpen, setIsOpen] = React.useState(false);

  const openMenu = (): void => {
    setIsOpen(true);
  };

  const closeMenu = (): void => {
    setIsOpen(false);
  };

  React.useEffect(() => {
    if (!isOpen) {
      return;
    }
    const onKeyDown = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') {
        closeMenu();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen]);

  return (
    <>
      <header
        className={styles.header}
        style={{ height: '60px' }}
      >
        <div className={styles.inner}>
          <Logo catalogCode={catalogCode} />

          <button
            type="button"
            className={styles.menuButton}
            aria-label="カテゴリメニューを開く"
            aria-expanded={isOpen}
            aria-controls="catalog-category-menu"
            onClick={openMenu}
          >
            <span className={styles.hamburger}>
              <span className={styles.hamburgerBar} />
            </span>
          </button>
        </div>
      </header>

      {isOpen && (
        <div
          className={styles.backdrop}
          role="presentation"
          onClick={closeMenu}
        />
      )}

      {isOpen && (
        <aside
          className={styles.drawer}
          id="catalog-category-menu"
          role="dialog"
          aria-modal="true"
        >
          <div className={styles.drawerHeader}>
            <div className={styles.drawerTitle}>カテゴリ</div>
            <button
              type="button"
              className={styles.closeButton}
              aria-label="閉じる"
              onClick={closeMenu}
            >
              ×
            </button>
          </div>

          <div className={styles.drawerBody}>
            {hasError && <div className={styles.menuMeta}>カテゴリの取得に失敗しました。</div>}

            <ul className={styles.menuList}>
              {categories?.map((category) => (
                <li
                  key={category.code}
                  className={styles.menuItem}
                >
                  <a
                    className={styles.menuLink}
                    href={toCatalogCategoryPath(catalogCode, category.code)}
                  >
                    {category.name}
                  </a>
                </li>
              ))}
              <li className={styles.menuItem}>
                <a
                  className={styles.menuLink}
                  href="/contacts"
                >
                  お問い合わせ
                </a>
              </li>
            </ul>
          </div>
        </aside>
      )}
    </>
  );
};
